import Http from "./base-http";

class TaskExemption extends Http {
  addTaskExemption(variables) {
    return this.create(variables);
  }
  deleteTaskExemp(id) {
    return this.destroy(id);
  }
}
const taskExemption = new TaskExemption({
  modelUrlPrefix : "TaskExemption"
});
export default taskExemption;